"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LoadingSpinner", {
    enumerable: true,
    get: function() {
        return LoadingSpinner;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _propTypes = /*#__PURE__*/ _interopRequireDefault(require("prop-types"));
var _reactLottie = /*#__PURE__*/ _interopRequireDefault(require("react-lottie"));
var _lottieColorify = require("lottie-colorify");
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _defaultLoadingBarAnimationWhite = /*#__PURE__*/ _interopRequireDefault(require("./animations/defaultLoadingBarAnimationWhite"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_OPTIONS = {
    loop: true,
    autoplay: true
};
var colorCache = new Map();
var ColorExp = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
var isValidColor = function(value) {
    return value && ColorExp.test(value);
};
var safeReplaceColor = function(originalColor, newColor, animation) {
    try {
        // If the new color is not valid we return the current animation as is
        // This is to avoid replace from throwing since passing a invalid color
        // will make it fail catastrophically
        if (!isValidColor(newColor)) {
            return animation;
        }
        return (0, _lottieColorify.replaceColor)(originalColor, newColor, animation);
    } catch (e) {
        console.log("Failed", e);
        return animation;
    }
};
var safeColorify = function(colorList, animation) {
    try {
        return (0, _lottieColorify.colorify)(colorList, animation);
    } catch (e) {
        return animation;
    }
};
var LoadingSpinnerProps = {
    color: _propTypes.default.string,
    size: _propTypes.default.oneOf([
        "sm",
        "md",
        "lg"
    ]),
    width: _propTypes.default.number,
    height: _propTypes.default.number,
    className: _propTypes.default.string,
    animation: _propTypes.default.object,
    colorList: _propTypes.default.array
};
var LoadingSpinner = function(param) {
    var color = param.color, _param_size = param.size, size = _param_size === void 0 ? "sm" : _param_size, width = param.width, height = param.height, className = param.className, _param_animation = param.animation, animation = _param_animation === void 0 ? _defaultLoadingBarAnimationWhite.default : _param_animation, colorList = param.colorList;
    var _useState = _slicedToArray((0, _react.useState)(null), 2), animationData = _useState[0], setAnimationData = _useState[1];
    (0, _react.useLayoutEffect)(function() {
        if (!color && !colorList) {
            setAnimationData(animation);
            return;
        }
        var cacheKey = {
            color: colorList || color,
            animation: animation
        };
        var cachedValue = colorCache.get(cacheKey);
        if (cachedValue) {
            setAnimationData(cachedValue);
            return;
        }
        var newValue;
        if (colorList) {
            newValue = safeColorify(colorList, animation);
        } else {
            newValue = safeReplaceColor("#ffffff", color, animation);
        }
        colorCache.set(cacheKey, newValue);
        setAnimationData(newValue);
    }, [
        color,
        colorList
    ]);
    var options = _objectSpreadProps(_objectSpread({}, DEFAULT_OPTIONS), {
        animationData: animationData
    });
    var _obj;
    return /*#__PURE__*/ _react.default.createElement("div", {
        "data-testid": "loading-spinner",
        className: (0, _classnames.default)((_obj = {
            "w-[20px] h-[20px]": size === "sm",
            "w-[40px] h-[40px]": size === "md",
            "w-[80px] h-[80px]": size === "lg"
        }, _defineProperty(_obj, "w-[".concat(width, "px]"), !!width), _defineProperty(_obj, "w-[".concat(height, "px]"), !!height), _obj), className)
    }, /*#__PURE__*/ _react.default.createElement(_reactLottie.default, {
        options: options
    }));
};
LoadingSpinner.displayName = "LoadingSpinner";
LoadingSpinner.propTypes = LoadingSpinnerProps;

//# sourceMappingURL=LoadingSpinner.js.map